export default __webpack_public_path__ + "static/media/na_icon.580b269a.svg";